import { render, staticRenderFns } from "./nav-app-institution.vue?vue&type=template&id=55b173e4"
import script from "./nav-app-institution.vue?vue&type=script&lang=js"
export * from "./nav-app-institution.vue?vue&type=script&lang=js"
import style0 from "./nav-app-institution.vue?vue&type=style&index=0&id=55b173e4&prod&lang=stylus"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports